import React from "react";
import { Form, Select, Input } from "antd";
import { isEmpty, find, get } from 'lodash';

const Option = Select.Option;

const displayValue = (value, items, idField) => {
  if (value) {
    return find(items, [idField, value]).name;
  } else {
    return ' ';
  }
};

const MultiSelectInput = ({
  values,
  errors,
  handleSubmit,
  setFieldValue,
  setFieldTouched,
  name,
  label,
  formItemLayout,
  placeholder,
  readOnly,
  idField,
  nameField,
  nameFields,
  onSelectionChanged,
  items
}) => (
    <Form.Item label={label} {...formItemLayout}
      hasFeedback={!!get(errors, name)}
      validateStatus={get(errors, name) && "error"}
      help={get(errors, name)}
    >
      {!readOnly &&
        <Select
          mode="multiple"
          showSearch
          optionFilterProp="children"
          filterOption={true}
          placeholder={placeholder}
          value={get(values, name)}
          onChange={value => {
            setFieldValue(name, value);
            if (onSelectionChanged) {
              onSelectionChanged(value)
            }
          }}
          onBlur={() => setFieldTouched(name)}
          notFoundContent={placeholder}
        >
          {
            items.map(o => <Option key={o[idField]} value={o[idField]}>{nameFields ? nameFields.map(i => o[i]).join(' - ') : nameField ? o[nameField] : o.name}</Option>)
          }
        </Select>
      }
      {readOnly &&
        <Input
          placeholder={placeholder}
          value={displayValue(values[name], items, idField)}
          readOnly={readOnly}
        />
      }
    </Form.Item>
  );

export default MultiSelectInput;
